import { pickBy } from 'lodash';

export default object => pickBy(object, x => x);
